<template>
  <div class="video gutter-md mb">
    <div class="padding">
      <iframe v-bind:title="frameTitle" v-bind:src="videoSource" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
    </div>
    <p class="caption">{{ caption }}</p>
  </div>
</template>


<!-- src="https://player.vimeo.com/video/249449021?title=0&byline=0&portrait=0"  -->
<script>
export default {
  name: 'videoEmbed',
  props: [
    'caption',
    'videoSource',
    'frameTitle'
  ],
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video {
  position: relative;
  width: 100%;
  margin: 0 auto;
}
.padding {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08);
}
iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.caption {
  text-align: center;
  font-style: italic;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  color: #707070;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/videoEmbed.vue